
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "PrintConfirm",
  components: {},
  props: {
    printConfirmDialogShowFlag: {
      type: Boolean,
      default: false,
    },
    printConfirmTable: {
      type: Array,
      default: [],
    },
  },
  watch: {
    printConfirmDialogShowFlag(newone, oldone) {
      console.log("包签打印前确认");
      console.log(newone);
      if (newone) {
        this.printConfirmDialogFormVisible = true;
      } else {
        this.printConfirmDialogFormVisible = false;
      }
    },
    printConfirmTable(newone, oldone) {
      console.log("包签打印前显示参数");
      console.log(newone);
      this.tableDataPrintConfirm = newone;
    },
  },
})
export default class extends Vue {
  private printConfirmDialogFormVisible = false;
  private tableDataPrintConfirm = [];

  private printConfirmDialogFormOK(flag) {
    console.log("打印前确认：" + flag);
    console.log("|FUNC|printConfirmDialogFormOK:" + flag);

    this.$emit("print-confirm", flag); //返回true

    this.printConfirmDialogFormVisible = false;
  }
}
